import React from "react";
import { Box, styled } from "@mui/material";
import background from "../assets/background.jpg";
import background2 from "../assets/background2.png";

const StyledVideoBox = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "100%",
  minHeight: "100vh",
  overflow: "auto",
}));

const StyledVideo = styled("video")({
  position: "fixed",
  width: "100vw",
  height: "56.25vw",
  minHeight: "100vh",
  left: "50%",
  top: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: -1,
  filter: "brightness(50%)",
  objectFit: "cover",
});

const StyledBackgroundImage = styled("img")({
  position: "fixed",
  width: "100vw",
  height: "100vh",
  left: "50%",
  top: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: -1,
  objectFit: "cover", // Ensures the image covers the available space
  filter: "brightness(80%)", // Optional: for dimming the image
});

const ContentContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

const BackgroundVideoContainer = React.memo(({ children, showGraphs }) => {
  return (
    <StyledVideoBox>
      <StyledBackgroundImage
        src={showGraphs ? background2 : background}
        alt="Background"
      />

      <ContentContainer>{children}</ContentContainer>
    </StyledVideoBox>
  );
});

export default BackgroundVideoContainer;
